import { call, fork, put, take, all, select } from "redux-saga/effects";
import axios from "axios";
import {
  disableScopeLoading,
  enableScopeLoading,
} from "../scope-loading/actions";
import { UnRegisterContractAction, UnRegisterScope } from "./types";
import { ScopeErrorAction } from "../scope-error/types";
import {
  cleanUpUnRegisterContract,
  setSKUsOPTIONS,
  setUploadedDocuments,
} from "./actions";
import * as API from "../../service/api";
import { mapApiSkus } from "../user/helper";
import { handleApiErrorToast } from "../../helper";
import toast from "react-hot-toast";
import { RootState } from "../root-reducer";

function* fetchSkusFlow(): Generator<any, void, any> {
  while (true) {
    const { payload: { deliveryDate = "", dealerId } = {} } = yield take(
      UnRegisterContractAction.GET_SKUsOPTIONS
    );
    yield put(enableScopeLoading(`${UnRegisterScope}-skus`));
    try {
      const { data = [] } = yield call(
        API.unRegisterContract.getSku,
        deliveryDate,
        dealerId
      );
      yield put(setSKUsOPTIONS(data.map(mapApiSkus)));
    } catch (error) {
      yield put(setSKUsOPTIONS([]));
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: `${UnRegisterScope}-skus`,
        error,
      });
    } finally {
      yield put(disableScopeLoading(`${UnRegisterScope}-skus`));
    }
  }
}
function* createUnRegisterContractFlow(): Generator<any, void, any> {
  while (true) {
    const { payload, dealerId, callback } = yield take(
      UnRegisterContractAction.CREATE_UNREGISTER_CONTRACT
    );
    yield put(enableScopeLoading(UnRegisterScope));
    try {
      const documents = yield select(
        (state: RootState) => state.unRegister.data.documents
      );
      payload.documentation = documents.map((fileUrl) => ({
        s3_url: fileUrl,
        file_name: fileUrl?.split("/")?.pop() || "",
      }));
      payload.source = "internal_portal";
      const data = yield call(
        API.unRegisterContract.insertUnRegisterContractItem,
        payload,
        dealerId
      );
      if (data?.contract_id) {
        yield put(cleanUpUnRegisterContract());
        callback();
      } else {
        toast.error(data?.message || "Failed to create unregister contract", {
          position: "bottom-center",
        });
      }
    } catch (error: any) {
      console.log("error: ", error);
      handleApiErrorToast(error, "Failed to create unregister contract");
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: UnRegisterScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(UnRegisterScope));
    }
  }
}
function* uploadInvoiceFlow(): Generator<any, void, any> {
  while (true) {
    const { files, dealerId, callback } = yield take(
      UnRegisterContractAction.UPLOAD_DOCUMENTS
    );
    yield put(enableScopeLoading(UnRegisterScope));
    try {
      const uploadFileUrls = yield all(
        files.map(function* (file) {
          const { url: uploadURL } = yield call(
            API.unRegisterContract.getUnRegisterPresignedURL,
            "invoice-files",
            file.type,
            dealerId,
            file.name.split(".").pop()
          );
          yield call(axios.put, uploadURL, file, {
            headers: {
              "Content-Type": file.type,
            },
          });
          const urlObj = new URL(uploadURL);
          urlObj.search = "";
          return urlObj.toString();
        })
      );

      yield put(setUploadedDocuments(uploadFileUrls));
      callback();
    } catch (error) {
      console.log(error);

      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: UnRegisterScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(UnRegisterScope));
    }
  }
}

export default function* UnRegisterContract(): Generator<any, void, any> {
  yield fork(fetchSkusFlow);
  yield fork(uploadInvoiceFlow);
  yield fork(createUnRegisterContractFlow);
}
